import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthCallbackComponent } from "./auth-callback/auth-callback.component";
import { HomeComponent } from "./components/home/home.component";
import { DefaultLayoutComponent } from "./containers/default-layout/default-layout.component";
import { AuthGuardService } from "./services/auth-guard.service";
// Import Containers
export const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full"
  },
  { path: 'auth-callback', component: AuthCallbackComponent },
  {
    path: '', component: DefaultLayoutComponent,
    data: { title: '' }, children: [
      { path: 'home', component: HomeComponent },
      {
        path: 'ho-so-khach-hang',
        loadChildren: () => import('../app/pages/ho-so-khach-hang/ho-so-khach-hang.module').then(m => m.HoSoKhachHangModule)
      },
      {
        path: 'tai-khoan-dang-nhap',
        loadChildren: () => import('../app/pages/tai-khoan-dang-nhap/tai-khoan-dang-nhap.module').then(m => m.TaiKhoanDangNhapModule)
      },
      {
        path: 'he-thong-dai-ly',
        loadChildren: () => import('../app/pages/he-thong-dai-ly/he-thong-dai-ly.module').then(m => m.HeThongDaiLyModule)
      },
    
     
    ], canActivate: [AuthGuardService]
  },
  
  // {
  //   path: 'pos', component: DefaultLayoutPosComponent,
  //   data: { title: '' }, children: [
  //     { path: 'home', component: HomeComponent },
  //     {
  //       path: 'danh-muc',
  //       loadChildren: () => import('../app/components/danh-muc/danh-muc.module').then(m => m.DanhMucModule)
  //     },
     
  //   ], canActivate: [AuthGuardService]
  // }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
